interface TimelineEvent {
    date: string;
    title: string;
    description: string;
    icon: string;
    isPending?: boolean;
}

export const timelineEvents: TimelineEvent[] = [
    {
        date: "17. März '25",
        title: "BeeHappy Heilbronn – Projektstart",
        description:
            "Zum Projektstart kamen Studierende mit den Initiatoren Markus Hagner und Lea Krück sowie den Beteiligten Imker Günter Hartmann und Christian Harms und Robin Gerold von Schwarz IT zusammen. An Stationen zu Imkerei, Sensorik und Projektidee gab es erste Einblicke – und der Einbau der Sensoren in den Bienenstock war die Grundlage für das digitale Zuhause der Bienen.",
        icon: "🚀",
    },
    {
        date: "April '25",
        title: "Einzug in den SmartHive",
        description:
            "Die Bienenstöcke wurden aufgestellt – inklusive selbstgebauter Holzdächer durch die Studenten. Imker Günter Hartmann setzte drei Bienenvölker in ihre neuen smarten Behausungen ein. Das Projekt startete mit der Installation der ersten Sensoren für Temperatur und Luftfeuchtigkeit.",
        icon: "🏠",
    },
    {
        date: "16. April '25",
        title: "Datenerhebung",
        description:
            "Wie gelangen Sensordaten aus dem Bienenstock in eine digitale Übersicht? Bei einer Kurzsession erhielten Studierende einen ersten Einblick in die Datenverarbeitung bei BeeHappy: von der Übertragung der Sensordaten bis zur strukturierten Ablage der Daten. Ziel des Workshop war es, den Studierenden alle Mittel in die Hand zu geben ihre eigene Datenbank zu, inklusive Zugängen und Schnittstelle (API-URL) zur Plattform, auf der die gesammelten Informationen künftig sichtbar werden und weiterverarbeitet werden können – zur Verfügung zu stellen.",
        icon: "📊",
    },
    {
        date: "09. Mai '25",
        title: "Der erste Honig",
        description:
            "Imker Günter Hartmann konnte den ersten Honig aus den frisch bezogenen Bienenstöcken ernten. Ein sichtbares Zeichen dafür, dass sich die Bienenvölker gut eingelebt haben – und ein schöner Moment für das gesamte Projektteam.",
        icon: "🍯",
    },
    {
        date: "13. Mai '25",
        title: "Grafana Workshop",
        description:
            "Im Workshop mit Robin Gerold stand das Visualisieren der gesammelten Sensordaten im Fokus. Gemeinsam mit Christian Harms wurden die verfügbaren Datensätze besprochen, bevor Robin den Teilnehmenden eine Einführung in Grafana gab und die Aufgabe stellte, basierend auf diesen Informationen ein eigenes Dashboard zu erstellen. Drei Gruppen machten sich im Anschluss direkt an die Umsetzung.",
        icon: "📈",
    },
    {
        date: "In Planung",
        title: "Computer Vision Integration",
        description:
            "Entwicklung und Integration von Computer Vision-Technologie zur automatisierten Überwachung der Bienenaktivität. Automatisierte Bienenzählung: Wie viele Bienen befinden sich aktuell im Stock?",
        icon: "👁️",
        isPending: true,
    },
    {
        date: "In Planung",
        title: "Audio-Frequenz Sensorik",
        description:
            "Installation und Kalibrierung von Frequenz-Audio-Sensoren zur Analyse der Bienenaktivität. Forschungsfrage: Wie verändert sich die Bienenaktivität in Reaktion auf verschiedene Schallfrequenzen?",
        icon: "🔊",
        isPending: true,
    },
    {
        date: "In Planung",
        title: "Waagen-Sensor System",
        description:
            "Implementierung von Präzisionswaagen zur kontinuierlichen Gewichtsmessung der Bienenstöcke. Analyse: Wie beeinflussen Umweltbedingungen die Honigproduktion?",
        icon: "⚖️",
        isPending: true,
    },
    {
        date: "In Planung",
        title: "Luftqualitäts-Monitoring",
        description:
            "Installation von Luftqualitätssensoren zur Überwachung der Lebensbedingungen der Bienen. Forschung: Wie beeinflusst die Luftqualität die Bienengesundheit und -aktivität?",
        icon: "🌬️",
        isPending: true,
    },
    {
        date: "In Planung",
        title: "Hornissen-Abwehr MVP",
        description:
            "Entwicklung des MVP (Minimum Viable Product) für die Frequenz-Sensor-basierte Früherkennung und den Schutz vor Bedrohungen wie der Asiatischen Hornisse.",
        icon: "🛡️",
        isPending: true,
    },
];
